import { render } from "./OurClinicsComponent.vue?vue&type=template&id=56fb3ca6"
import script from "./OurClinicsComponent.vue?vue&type=script&lang=js"
export * from "./OurClinicsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__